import React, { useEffect, useState } from "react";
import { Layout, Menu, Modal, Button, Upload, Select, message, Image, Spin, Tooltip, Checkbox, Input, Popconfirm } from "antd";
import notification from "../../utils/notification";
import { LaptopOutlined, InboxOutlined, PlusOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, FilePdfFilled, FileImageOutlined, FileWordOutlined, FilePdfOutlined, FileOutlined } from "@ant-design/icons";
import './Collaterals.css';
import { CollateralRenameCategory, deleteCategoryCollaterals, deleteCollaterals, getCollaterals, RenameFilesCollaterals, uploadCollaterals } from "../../redux/actions/collaterals.action";
import { useDispatch, useSelector } from "react-redux";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import { getRights } from "../../redux/actions/userRights.action";
import { ReadCookie } from "../../utils/readCookie";
import { TabTitle } from "../../utils/GeneralFunction";

const { Sider, Content } = Layout;
const { SubMenu, Item } = Menu;
const { Option } = Select;
const { Dragger } = Upload;

const Collaterals = ({ token }) => {
  TabTitle("Collaterals")
  const [selectedPdf, setSelectedPdf] = useState("Select File");
  const [openKeys, setOpenKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [fileType, setFileType] = useState("pdf");
  const [fileList, setFileList] = useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [modalLoading, setModalLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isRenameEnabled, setIsRenameEnabled] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const [newCategoryName, setNewCategoryName] = useState("");
  const [searchTerms, setSearchTerms] = useState({});
  const [uploadKey, setUploadKey] = useState(Date.now());
  const menuId = ReadCookie('menuId')

  //for files rename
  const [fileRenameState, setFileRenameState] = useState({
    visible: false,
    file: null,
    newName: "",
    loading: false
  });


  //for Submenu rename
  const [categoryRenameState, setCategoryRenameState] = useState({
    selectedCategory: null,
    visible: false,
    newName: "",
    loading: false
  });


  const dispatch = useDispatch();
  const { Collateral, userRights } = useSelector((state) => state);

  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const handleMenuClick = ({ key }) => {
    const selected = Collateral?.payload?.data?.find((item) => item?.sno == key);
    setSelectedFile(selected);
    setSelectedPdf(`${selected?.file_category} : ${selected?.file_name}`);
  };

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    setSearchTerms({});
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  const showModal = (subMenuKey) => {
    setActiveSubMenu(subMenuKey);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setFileList([]);
    setFileType("pdf");
    setNewFileName("");
    setIsRenameEnabled(false);
    setNewCategoryName("");
    setModalLoading(false);
    setUploadKey(Date.now()); // force Dragger remount
  };

  const handleOk = () => {
    if (!fileList.length) return;

    if (activeSubMenu === "New Category" && !newCategoryName.trim()) {
      notification("error", "Please enter a category name.");
      return;
    }

    if (isRenameEnabled && !newFileName.trim()) {
      notification("error", "Please enter a File name.");
      return;
    }

    setModalLoading(true);

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);
    formData.append("type", fileType);
    formData.append(
      "category",
      activeSubMenu === "New Category" ? newCategoryName.trim() : activeSubMenu
    );

    if (isRenameEnabled && newFileName.trim()) {
      formData.append("file_name", newFileName.trim());
    }

    dispatch(uploadCollaterals(token, formData)).then((res) => {
      setModalLoading(false);
      if (res?.type === "ADD_COLLATERALS_SUCCESS") {
        setFileList([]);
        setNewFileName("");
        setIsRenameEnabled(false);
        setNewCategoryName("");
        notification("success", "File Uploaded Successfully");
        setIsModalVisible(false);
        setFileType("pdf");
        dispatch(getCollaterals(token));
      } else {
        if (res?.payload?.response?.data?.message) {
          notification("error", res?.payload?.response?.data?.message, res?.payload?.response?.data?.detail);
          setIsRenameEnabled(true);
        }
        else {
          notification("error", "File Upload Failed. Please try again.");
        }
      }
      setModalLoading(false);
    });
  };

  useEffect(() => {
    dispatch(getCollaterals(token))
    dispatch(getRights(token, menuId))
  }, [menuId])

  const handleFileTypeChange = (value) => {
    setFileType(value);
    setFileList([])
    setNewFileName("");
    setIsRenameEnabled(false);
    setNewCategoryName("")
  };

  const uploadProps = {
    action: "https://httpbin.org/post",
    fileList: fileList, // Controlled fileList

    onChange({ file, fileList: newFileList }) {
      if (file.status !== 'error') {
        setFileList(newFileList.filter(f => f.status !== 'error'));
      }
    },

    beforeUpload: (file) => {
      const isAllowed =
        (fileType === "pdf" && file?.type === "application/pdf") ||
        (fileType === "doc" &&
          (file?.type === "application/msword" ||
            file?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) ||
        (fileType === "image" &&
          (file?.type === "image/jpeg" ||
            file?.type === "image/png" ||
            file?.type === "image/jpg"));

      if (!isAllowed) {
        message.error(`Only ${fileType.toUpperCase()} files are allowed.`);
      }

      return isAllowed || Upload.LIST_IGNORE;
    },

    accept:
      fileType === "pdf"
        ? ".pdf"
        : fileType === "doc"
          ? ".doc,.docx"
          : fileType === "image"
            ? ".jpg,.jpeg,.png"
            : "",

    multiple: false,
    maxCount: 1,
  };


  const renderSubMenuTitle = (title, key) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <span
        title={title}
        style={{
          flex: 1,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </span>

      {userRights?.payload?.can_edit && (
        <EditOutlined
          onClick={(e) => {
            e.stopPropagation();
            setCategoryRenameState({
              selectedCategory: { name: title, key },
              visible: true,
              newName: title,
              loading: false
            });
          }}
          style={{ marginLeft: 8 }}
        />
      )}

      {userRights?.payload?.can_delete && (
        <span className="menu-item-center-inline-flex">
          <Popconfirm
            title={
              <>
                You are trying to delete the category. <br />
                All files of this category will be deleted. <br />
                Are you sure you want to delete the category?
              </>
            }
            onConfirm={(e) => {
              e.stopPropagation();
              handleCategoryDelete(title);
            }}
            onCancel={(e) => e.stopPropagation()}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined
              onClick={(e) => e.stopPropagation()}
              className="menu-item-delete-icon collaterals-menu-delete-icon"
            />
          </Popconfirm>
        </span>
      )}

      {userRights?.payload?.can_add &&
        <Button
          type="link"
          icon={<PlusOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            showModal(title);
          }}
          style={{ marginLeft: "0px", padding: 0, marginRight: "0px" }}
        />
      }
    </div>
  );


  const handleDelete = (file) => {
    dispatch(deleteCollaterals(token, file?.sno)).then((res) => {
      if (res.type === "DELETE_COLLATERALS_SUCCESS") {
        setSelectedPdf("Select File");
        setSelectedFile(null);
        notification("success", "File Deleted");
      } else if (res.type === "DELETE_COLLATERALS_ERROR") {
        notification("error", "File not Deleted");
      }
      dispatch(getCollaterals(token));
    })
      .catch((error) => {
        notification("error", "Something went wrong");
      });
  };


  function downloadFile(fileUrl, fileType) {
    if (!fileUrl || !fileType) {
      alert("File URL ya type missing hai.");
      return;
    }

    // if (fileType === 'image') {
    //   // Image file download
    //   fetch(fileUrl)
    //     .then(response => {
    //       if (!response.ok) throw new Error("Image fetch failed");
    //       return response.blob();
    //     })
    //     .then(blob => {
    //       const url = URL.createObjectURL(blob);
    //       const a = document.createElement('a');
    //       a.href = url;
    //       a.download = fileUrl.split('/').pop() || 'image.jpg';
    //       a.style.display = 'none';
    //       document.body.appendChild(a);
    //       a.click();
    //       a.remove();
    //       URL.revokeObjectURL(url);
    //     })
    //     .catch(() => alert("Image download failed."));
    // }

    if (fileType === 'doc') {
      // Document file download
      fetch(fileUrl)
        .then(response => {
          if (!response.ok) throw new Error("Document fetch failed");
          return response.blob();
        })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileUrl.split('/').pop() || 'document.doc';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(() => alert("Document download failed."));
    }

    else {
      alert("Unsupported file type.");
    }
  }


  const handleRenameOk = () => {
    if (!fileRenameState.newName.trim()) {
      notification("error", "Please enter a new file name.");
      return;
    }
    setFileRenameState(prev => ({ ...prev, loading: true }));

    const formData = new FormData();
    formData.append("file_name", fileRenameState.newName.trim());

    dispatch(RenameFilesCollaterals(token, formData, fileRenameState.file?.sno)).then(res => {
      if (res.type === "UPDATE_COLLATERALS_SUCCESS") {
        notification("success", "File Renamed Successfully");
        dispatch(getCollaterals(token));
        setFileRenameState({ visible: false, file: null, newName: "", loading: false });
        setSelectedPdf("Select File");
        setSelectedFile(null);

      } else {
        notification("error", "File Rename Failed");
        setFileRenameState(prev => ({ ...prev, loading: false }));
      }
    });
  };


  const getFileIconFromType = (fileType) => {
    switch (fileType?.toLowerCase()) {
      case "pdf":
        return <FilePdfOutlined style={{ color: "#e74c3c" }} />; // Red
      case "image":
        return <FileImageOutlined style={{ color: "#27ae60" }} />; // Green
      case "doc":
        return <FileWordOutlined style={{ color: "#2980b9" }} />; // Blue
      default:
        return <FileOutlined style={{ color: "#7f8c8d" }} />; // Gray
    }
  };


  const handleCategoryRename = () => {
    if (!categoryRenameState.newName.trim()) {
      notification("error", "Please enter a new category name.");
      return;
    }

    setCategoryRenameState((prev) => ({ ...prev, loading: true }));

    const formData = new FormData();
    formData.append("file_category", categoryRenameState.selectedCategory.name);
    formData.append("new_file_category", categoryRenameState.newName.trim());

    dispatch(CollateralRenameCategory(token, formData)).then((res) => {
      if (res.type === "UPDATE_SUB_COLLATERALS_SUCCESS") {
        notification("success", "Category renamed successfully");
        dispatch(getCollaterals(token));
      } else {
        notification("error", "Rename failed");
      }

      setCategoryRenameState({
        selectedCategory: null,
        visible: false,
        newName: "",
        loading: false
      });
    });
  };


  const handleCategoryDelete = (Category) => {
    // const formData = new FormData();
    // formData.append("file_category", Category);
    dispatch(deleteCategoryCollaterals(token, Category)).then((res) => {
      if (res.type === "DELETE_CATEGORY_COLLATERALS_SUCCESS") {
        setSelectedFile(null);
        notification("success", "File Deleted");
      } else if (res.type === "DELETE_CATEGORY_COLLATERALS_ERROR") {
        notification("error", "File not Deleted");
      }
      dispatch(getCollaterals(token));
    })
      .catch((error) => {
        notification("error", "Something went wrong");
      });
  };


  console.log("fileList", fileList)



  return (
    <Layout style={{ height: "84vh" }}>
      <Sider
        className="collateral-sidebar"
        width={380}
      >
        <div style={{ position: "relative", height: "100%", display: "flex", flexDirection: "column" }}>
          {/* Scrollable menu area */}
          <div style={{ flex: 1, overflowY: "auto" }}>
            <Menu
              mode="inline"
              className="sider-menu"
              onClick={handleMenuClick}
              openKeys={openKeys}
              onOpenChange={handleOpenChange}
            >
              {[...new Set(Collateral?.payload?.data.map(item => item?.file_category))]
                .sort((a, b) => a.localeCompare(b))
                .map((category, index) => {
                  const key = `sub${index + 1}`;
                  const searchTerm = searchTerms[key] || "";

                  const files = Collateral?.payload?.data.filter(
                    (item) =>
                      item?.file_category === category &&
                      item?.file_name?.toLowerCase().includes(searchTerm.toLowerCase())
                  );

                  return (
                    <SubMenu
                      key={key}
                      icon={<LaptopOutlined />}
                      className="submenu-wrapper submenu-custom collaterals-submenus-height"
                      title={renderSubMenuTitle(category, key)}
                    >
                      {/* 🔍 Search Box */}
                      <div style={{ padding: "8px" }}>
                        <Input
                          placeholder="Search files..."
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerms({ ...searchTerms, [key]: e.target.value })
                          }
                          allowClear
                          size="small"
                        />
                      </div>

                      {/* 📄 File Items */}
                      {files && files.length > 0 ? (
                        files.map((file) => (
                          <Item className="collaterals-subitems" key={file?.sno}>
                            <span className="menu-item-text-name" title={file?.file_name}>
                              {getFileIconFromType(file?.file_type)}
                              <span className="menu-item-file-text">{file?.file_name}</span>
                            </span>
                            <span>
                              {userRights?.payload?.can_edit && (
                                <span
                                  className="menu-item-center-inline-flex"
                                  style={{ marginRight: "12px" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setFileRenameState({
                                      visible: true,
                                      file: file,
                                      newName: file.file_name,
                                      loading: false
                                    });
                                  }}
                                >
                                  <EditOutlined className="menu-item-edit-icon" />
                                </span>
                              )}

                              {userRights?.payload?.can_delete && (
                                <span className="menu-item-center-inline-flex">
                                  <Popconfirm
                                    title="Are you sure you want to delete this file?"
                                    onConfirm={(e) => {
                                      e.stopPropagation();
                                      handleDelete(file);
                                    }}
                                    onCancel={(e) => e.stopPropagation()}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <DeleteOutlined
                                      onClick={(e) => e.stopPropagation()}
                                      className="menu-item-delete-icon"
                                    />
                                  </Popconfirm>
                                </span>
                              )}
                            </span>
                          </Item>
                        ))
                      ) : (
                        <Item disabled>No files</Item>
                      )}
                    </SubMenu>
                  );
                })}
            </Menu>
          </div>

          {userRights?.payload?.can_add && <div style={{
            padding: "8px",
            background: "#fff",
            borderTop: "1px solid #f0f0f0"
          }}>
            <Button
              type="primary"
              block
              onClick={() => showModal('New Category')}
            >
              Open New Category
            </Button>
          </div>}

        </div>
      </Sider>

      <Content className="content-wrapper">
        <h3 className="content-header-row">
          <span>{selectedPdf}</span>
          {['doc'].includes(selectedFile?.file_type?.toLowerCase()) && (
            <Tooltip title="Download File">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => downloadFile(selectedFile?.file_url, selectedFile?.file_type)}
              >
                Download
              </Button>
            </Tooltip>
          )}
        </h3>
        <div className="content-container">
          {Collateral?.payload?.data?.length > 0 && selectedFile?.file_url && (() => {
            const type = selectedFile?.file_type?.toLowerCase();

            if (type === 'pdf') {
              return (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <div className="pdf-viewer-wrapper">
                    <div className="pdf-toolbar">
                      <Toolbar>
                        {(props) => {
                          const {
                            CurrentPageInput,
                            ZoomIn,
                            ZoomOut,
                            GoToNextPage,
                            GoToPreviousPage,
                            Download,
                            Print,
                            // Remove `SwitchTheme`, `Open`
                          } = props;

                          return (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <GoToPreviousPage />
                                <CurrentPageInput />
                                <GoToNextPage />
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <ZoomOut />
                                <ZoomIn />
                                <Download />
                                <Print />
                              </div>
                            </div>


                          );
                        }}
                      </Toolbar>
                    </div>

                    <div className="pdf-viewer-body">
                      <Viewer fileUrl={selectedFile?.file_url} plugins={[toolbarPluginInstance]} />
                    </div>
                  </div>
                </Worker>
              );
            }

            if (['image'].includes(type)) {
              return (
                <div style={{ textAlign: 'center' }}>
                  <Image
                    src={selectedFile.file_url}
                    alt="Preview"
                    className="image-style"
                    preview={{
                      mask: (
                        <div>
                          <div>Click to preview</div>
                          <div>Right click and save as to download</div>
                        </div>
                      ),
                    }}
                    fallback="https://via.placeholder.com/400x300?text=Image+Not+Available"
                  />
                </div>
              );
            }
            if (['doc'].includes(type)) {
              return (
                <>
                  {loading && (
                    <div className="doc-loading-spinner">
                      <Spin size="large" />
                    </div>
                  )}
                  <iframe
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedFile.file_url)}`}
                    className="doc-iframe-viewer"
                    style={{ display: loading ? 'none' : 'block' }}
                    title="Word Preview"
                    onLoad={() => setLoading(false)}
                  />
                </>
              );
            }
            return <p style={{ textAlign: 'center', padding: '20px' }}>Unsupported file type.</p>;
          })()}
        </div>
      </Content>

      <Modal
        width={750}
        title={activeSubMenu === 'New Category' ? 'Open New Category' : `Upload for ${activeSubMenu}`}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={modalLoading}
        okButtonProps={{
          disabled:
            fileList.length === 0 || (fileList.length > 0 && fileList[0].status !== 'done') ||
            (activeSubMenu === 'New Category' && !newCategoryName.trim()) ||
            (isRenameEnabled && !newFileName.trim()),
        }}
      >
        {activeSubMenu === 'New Category' && (
          <>
            <p>Enter New Category Name:</p>
            <Input
              placeholder="Enter category name"
              value={newCategoryName}
              onChange={(e) => {
                const value = e.target.value;
                setNewCategoryName(value);
                if (value.trim() === "") {
                  setFileList([]);
                }
              }}
              style={{ marginBottom: "16px" }}
            />
          </>
        )}

        {(activeSubMenu !== 'New Category' || newCategoryName.trim() !== "") && (
          <>
            <p>Select File Type:</p>
            <Select
              value={fileType}
              style={{ width: "100%", marginBottom: "16px" }}
              onChange={handleFileTypeChange}
            >
              <Option value="pdf">PDF</Option>
              <Option value="doc">Document</Option>
              <Option value="image">Image</Option>
            </Select>

            <Dragger key={uploadKey} {...uploadProps} fileList={fileList}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Only {fileType.toUpperCase()} files are accepted.
              </p>
            </Dragger>

            {fileList.length > 0 && fileList[0].status === 'done' && (
              <>
                <Checkbox
                  checked={isRenameEnabled}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setIsRenameEnabled(checked);
                    if (!checked) {
                      setNewFileName("");
                    }
                  }}
                  style={{ marginTop: "16px" }}
                >
                  Do you want to rename the file?
                </Checkbox>

                {isRenameEnabled && (
                  <Input
                    placeholder="Enter new file name"
                    value={newFileName}
                    onChange={(e) => setNewFileName(e.target.value)}
                    style={{ marginTop: "8px" }}
                  />
                )}
              </>
            )}
          </>
        )}
      </Modal>

      <Modal
        title="Rename File"
        visible={fileRenameState.visible}
        confirmLoading={fileRenameState.loading}
        onOk={handleRenameOk}
        onCancel={() =>
          setFileRenameState({
            visible: false,
            file: null,
            newName: "",
            loading: false
          })}
        okText="Rename"
        cancelText="Cancel"
      >
        <Input
          placeholder="Enter new file name"
          value={fileRenameState.newName}
          onChange={(e) =>
            setFileRenameState((prev) => ({ ...prev, newName: e.target.value }))
          }
        />
      </Modal>

      <Modal
        visible={categoryRenameState.visible}
        title="Rename Category"
        onOk={handleCategoryRename}
        confirmLoading={categoryRenameState.loading}
        onCancel={() => {
          setCategoryRenameState({
            selectedCategory: null,
            visible: false,
            newName: "",
            loading: false
          });
        }}
      >
        <Input
          placeholder="Enter new category name"
          value={categoryRenameState.newName}
          onChange={(e) =>
            setCategoryRenameState((prev) => ({ ...prev, newName: e.target.value }))
          }
        />
      </Modal>

    </Layout>
  );
};

export default Collaterals;
